/* eslint-disable no-restricted-syntax */
export let localPlatformFeatureFlagsPromise: Promise<void> | undefined = undefined;

export const localPlatformFeatureFlags: Record<string, boolean> = {};

export const loadLocalPlatformFeatureFlags = () => {
  if (localPlatformFeatureFlagsPromise) {
    return localPlatformFeatureFlagsPromise;
  }

  localPlatformFeatureFlagsPromise = (async () => {
    const { fetchPlatformFeatureFlags } = await import('./fetchers');
    const flags = await fetchPlatformFeatureFlags();

    flags.forEach((flag) => {
      localPlatformFeatureFlags[flag.id] = Boolean(flag.value);
    });
  })();

  return localPlatformFeatureFlagsPromise;
};
